import "../../../resources/less/components/InfoGuidedTutorialPopup/InfoGuidedTutorialPopup.less";
import MultiPanelsNanoPopup from "../Popups/MultiPanelsNanoPopup";
import RestPromise from "../../utils/RestPromise";
import NanoPopupQueue from "../Popups/NanoPopupQueue";

export default class InfoGuidedTutorialPopup extends MultiPanelsNanoPopup {
  private infoGuidedTutorialBtn: JQuery<HTMLElement>;

  constructor() {
    super({
      target: "#info-guided-tutorial-popup",
      disabledBackPanel: true,
    });
    this.infoGuidedTutorialBtn = $(".js-open-tutorial-info-btn");

    if (this.currentTarget.data("displayFirstTime") === 1) {
      this.goTo(1);
      NanoPopupQueue.instance.Add(this, 20);
    }

    // Topbar button for guided tutorial popup
    this.infoGuidedTutorialBtn.on("click", () => {
      this.goTo(4);
      this.Show();
    });
  }

  public override Hide() {
    super.Hide();
    // Save that the popup has been displayed on first time
    if (this.currentTarget.data("displayFirstTime") === 1) {
      RestPromise.Create("/rest/demo/guided-tutorial", "POST");
    }
  }
}
